var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageSquareIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1244 0H2.87491C1.56685 0 0.5 1.07445 0.5 2.35818V13.0877C0.5 14.4051 1.56685 15.4459 2.87491 15.4459H6.43727V18.5515C6.43727 18.9159 6.85473 19.1289 7.14677 18.9141L11.7816 15.4123H17.1251C18.4331 15.4123 19.5 14.3378 19.5 13.0541V2.35818C19.4993 1.07445 18.4639 0 17.1244 0ZM5.24981 8.93569C4.59115 8.93569 4.06236 8.40313 4.06236 7.77341C4.06236 7.14369 4.59115 6.61114 5.24981 6.61114C5.90848 6.61114 6.43727 7.14369 6.43727 7.77341C6.43727 8.40313 5.94002 8.93569 5.24981 8.93569ZM9.99963 8.93569C9.34096 8.93569 8.81218 8.40313 8.81218 7.77341C8.81218 7.14369 9.34096 6.61114 9.99963 6.61114C10.6583 6.61114 11.1871 7.14369 11.1871 7.77341C11.1871 8.40313 10.6898 8.93569 9.99963 8.93569ZM14.7494 8.93569C14.0908 8.93569 13.562 8.40313 13.562 7.77341C13.562 7.14369 14.0908 6.61114 14.7494 6.61114C15.4081 6.61114 15.9369 7.14369 15.9369 7.77341C15.9369 8.40313 15.4397 8.93569 14.7494 8.93569Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSquareIcon);
export default __webpack_public_path__ + "static/media/message-square-icon.c1d8ccfa9c8d48d0371bd43fc718465b.svg";
export { ForwardRef as ReactComponent };